import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export function PublicGiveTributeFields({
  tributeType,
  honoreeName,
  displayAnonymous,
  onTributeTypeChange,
  onHonoreeNameChange,
  onDisplayAnonymousChange,
}: {
  tributeType: 'honor' | 'memory' | null
  honoreeName: string
  displayAnonymous: boolean
  onTributeTypeChange: (value: 'honor' | 'memory' | null) => void
  onHonoreeNameChange: (value: string) => void
  onDisplayAnonymousChange: (value: boolean) => void
}) {
  return (
    <div className="space-y-3 border-t border-border pt-4">
      {!tributeType ? (
        <Button
          type="button"
          variant="outline"
          className="border-dashed"
          onClick={() => onTributeTypeChange('honor')}
        >
          + Add tribute
        </Button>
      ) : (
        <div className="space-y-3">
          <div className="flex items-center justify-between gap-3">
            <p className="text-body-sm font-medium">Tribute</p>
            <Button
              type="button"
              variant="ghost"
              className="h-8 px-2 text-caption text-muted-foreground"
              onClick={() => {
                onTributeTypeChange(null)
                onHonoreeNameChange('')
                onDisplayAnonymousChange(false)
              }}
            >
              Clear
            </Button>
          </div>
          <div className="grid gap-3 sm:grid-cols-2">
            <div className="space-y-2">
              <Label htmlFor="give-tribute-type">Tribute type</Label>
              <Select
                value={tributeType}
                onValueChange={(value) => onTributeTypeChange(value as 'honor' | 'memory')}
              >
                <SelectTrigger id="give-tribute-type" aria-label="Tribute type" className="h-8">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="honor">In honor of</SelectItem>
                  <SelectItem value="memory">In memory of</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div className="space-y-2">
              <Label htmlFor="give-honoree">Honoree name</Label>
              <Input
                id="give-honoree"
                value={honoreeName}
                onChange={(event) => onHonoreeNameChange(event.target.value)}
              />
            </div>
          </div>
          <label htmlFor="give-display-anonymous" className="flex items-start gap-2 text-body-sm">
            <Checkbox
              id="give-display-anonymous"
              checked={displayAnonymous}
              onCheckedChange={(checked) => onDisplayAnonymousChange(checked === true)}
            />
            <span>Don&apos;t show my name publicly</span>
          </label>
        </div>
      )}
    </div>
  )
}
